import { SVGProps } from 'react';

export default function CloseLeftNavIcon(props: SVGProps<SVGSVGElement>) {
  return (
    
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5 2.5C17.721 2.5 17.933 2.5878 18.0893 2.74408C18.2455 2.90036 18.3333 3.11232 18.3333 3.33333V16.6667C18.3333 16.8877 18.2455 17.0996 18.0893 17.2559C17.933 17.4122 17.721 17.5 17.5 17.5H2.50001C2.27899 17.5 2.06703 17.4122 1.91075 17.2559C1.75447 17.0996 1.66667 16.8877 1.66667 16.6667V3.33333C1.66667 3.11232 1.75447 2.90036 1.91075 2.74408C2.06703 2.5878 2.27899 2.5 2.50001 2.5H17.5ZM16.6667 4.16667H3.33334V15.8333H16.6667V4.16667ZM15 5.83333V14.1667H13.3333V5.83333H15Z"
          fill="currentcolor"
          fillOpacity="0.7"
        />
      </svg>
  );
}
